import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanLoad, Route, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs';

import { RdsEulaService } from './eula.service';

/**
 * Ensure the user has signed the EULA before activating/loading the route.
 *
 * @author Will Davis <will.davis@mtna.us>
 */
@Injectable({ providedIn: 'root' })
export class RdsEulaGuard implements CanLoad {
  constructor(private rdsEulaService: RdsEulaService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
    return this._handleEula();
  }

  canLoad(route: Route): boolean | Observable<boolean> {
    return this._handleEula();
  }

  /**
   * If the user has already signed, proceed.
   * Otherwise, show the EULA if one exists.
   */
  private _handleEula(): boolean | Observable<boolean> {
    return this.rdsEulaService.hasUserSigned() || this.rdsEulaService.show();
  }
}
